/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordConfirmDto
 */
export interface ResetPasswordConfirmDto {
    /**
     * 
     * @type {number}
     * @memberof ResetPasswordConfirmDto
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordConfirmDto
     */
    otp: string;
}

/**
 * Check if a given object implements the ResetPasswordConfirmDto interface.
 */
export function instanceOfResetPasswordConfirmDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "otp" in value;

    return isInstance;
}

export function ResetPasswordConfirmDtoFromJSON(json: any): ResetPasswordConfirmDto {
    return ResetPasswordConfirmDtoFromJSONTyped(json, false);
}

export function ResetPasswordConfirmDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordConfirmDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'otp': json['otp'],
    };
}

export function ResetPasswordConfirmDtoToJSON(value?: ResetPasswordConfirmDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'otp': value.otp,
    };
}

